// 语音包调整顺序操作Map
export const LAUGHTER_SORT_OPERATION = {
  FINISH: 'finish', // 完成Sort， 发送请求到后端接口
  CANCEL: 'cancel', // 取消Sort， 不发送请求
};

// 语音包数据的特殊group_type
export const LAUGHTER_SPECIAL_GROUP_TYPE = {
  DEFAULT: 'default',
  FAVORITE: 'favorite',
};

// 语音包数据的特殊item_type
export const LAUGHTER_SPECIAL_ITEM_TYPE = {
  ADD: 'add',
};
